module.exports = __webpack_public_path__ + "static/Nsure-6236a36ca5b145aec117df8be4b1aa88.png";